export enum EventType {
    RESIZE = "resize",
    SCROLL = "scroll",
    SUBMIT = "submit",
    CLICK = "click",
    DISPLAY = "display",
    CHANGE = "change",
    INPUT = "input",
    ORIENTATION_CHANGE = "orientationchange",
    MOUSELEAVE = "mouseleave",
    MOUSEWHEEL = "mousewheel",
    MOUSEMOVE = "mousemove"
}
